import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { INITIAL_ADMIN_TASK_LOCATION_COORDINATES } from '../../../../app.config.vars/stored';
const RecenterMap = ({ marker }) => {
    const map = useMap();
    useEffect(() => {
        if (marker) {
            map.setView(marker, 15); // center on marker
        }
        else {
            map.setView([INITIAL_ADMIN_TASK_LOCATION_COORDINATES.lat, INITIAL_ADMIN_TASK_LOCATION_COORDINATES.lng], 15); // fallback to initial coords
        }
    }, [marker, map]);
    return null;
};
export default RecenterMap;
